/**
 * Builds a Knack filter rule that excludes assets flagged off the dispatcher.
 * Laborer uses a per-record Yes/No field; equipment uses a numeric lookup
 * (0/1) that mirrors the connected EQUIPMENT_TYPE's exclusion flag.
 * @param {string} assetType - 'laborer' | 'equipment'
 * @param {object} fields - HumanFields entry for the asset type
 * @return {object|null} filter rule or null if asset type has no exclusion field
 */
export default function dispatcherExclusionRule(assetType, fields) {
  if (assetType === 'laborer' && fields.EXCLUDE_FROM_DISPATCHER) {
    return {
      field: fields.EXCLUDE_FROM_DISPATCHER,
      operator: 'is not',
      value: 'Yes',
    }
  }
  if (
    assetType === 'equipment' &&
    fields.EQUIPMENT_TYPE_EXCLUDED_FROM_DISPATCHER
  ) {
    return {
      field: fields.EQUIPMENT_TYPE_EXCLUDED_FROM_DISPATCHER,
      operator: 'is',
      value: 0,
    }
  }
  return null
}
